<template>
  <div class="header-wrapper">
    <!-- course_id：10032498时，显示联想LOGO -->
    <!-- <div class="header-content" :class="{ 'header-content-lenovo': course_id == 10032498 }"> -->
    <!-- logoUrl不为空时，不展示松鼠logo -->
    <div class="header-content" :class="{ 'header-content-lenovo': logoUrl !== '' }">
      <div class="cource-info">
        <h2>{{ studentInfo.course_name }}</h2>
      </div>
      <div class="game-info">
        <img class="diamond" src="./images/diamond.png" alt="宝石" />
        <span class="num">{{ crtstalNum }}</span>
      </div>
      <div class="student-info">
        <div class="avatar">
          <div class="inner">
            <img v-if="avatarList.length" :src="LocalAvatar" alt="" />
          </div>
        </div>
        <div class="name-level">
          <p>{{ studentInfo.real_name }}</p>
          <p>Lv.{{ studentInfo.level }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import {getUserLocalData } from '@/utils/auth'

export default {
  name: "Header",
  data() {
    return {
      avatarList: [
         require('./images/avatar_1.png'),
         require('./images/avatar_2.png')
      ],
      LocalAvatar: '', // 根据用户ID后一位数取余
      logoUrl: '',
    };
  },
  props: {
    studentInfo: {
      type: Object,
      default: () => {
        return  {
          course_name: '',
          course_id: '',
          name: '',
          level: '',
          num: 0,
          avatar: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "learnInfo",
      "crtstalNum"
    ]),
  },
  created (){
  },
  async mounted() {
    const { user_id, course_id, account_id } = getUserLocalData()
    this.course_id = course_id;
    // getLogo 接口不再调用
    // await getLogo(account_id)
    const logo = JSON.parse(sessionStorage.getItem(`${account_id}-ChangeLogoUrl`)) || {};
    console.log(logo, 'logo', logo.logoUrl,this.logoUrl );
    this.logoUrl = logo.logoUrl || '';
    if(this.$route.name!=='questionCms') {
      let str = user_id.toString()
      let lastIdNum = str.substr(str.length - 1,1)
      this.LocalAvatar = this.avatarList[(lastIdNum % 2)]
    }else{
      this.LocalAvatar = this.avatarList[0]
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.header-wrapper {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top:0;
  left:50%;
  -webkit-transform: translate(-50%,0);
  -moz-transform: translate(-50%,0);
  -ms-transform: translate(-50%,0);
  -o-transform: translate(-50%,0);
  transform: translate(-50%,0);
  .header-content {
    /*width: 1366px;*/
    /*height:197px;*/
    width:1920px;
    max-width:1920px;
    height: 130px;
    background: url("./images/bg_study_top1.png") no-repeat center top;
    /*background: url("./images/bg_study_top.png") no-repeat center;*/
    -webkit-background-size:100%;
    background-size:100%;
    margin: 0 auto;
    margin-left:-277px;
    &.header-content-lenovo {
      background: url("./images/bg_study_top1_lenovo.png") no-repeat center top;
      /*background: url("./images/bg_study_top.png") no-repeat center;*/
      -webkit-background-size:100%;
      background-size:100%;
    }
    .cource-info {
      float: left;
      font-size: 18px;
      font-family: Helvetica;
      line-height: 22px;
      margin: 24px 0 0 420px;
      h2 {
        color: rgba(144, 255, 252, 1);
        font-weight: 400;
      }
    }
    .student-info {
      float: right;
      display: flex;
      align-items: center;
      justify-content:flex-start;
      margin-top: 6px;
      margin-right: 46px;
      display: flex;
      align-items: center;
      .avatar {
        display: inline-block;
        width: 56px;
        height: 56px;
        box-shadow: 0px 2px 4px 0px rgba(26, 69, 121, 0.35);
        border-radius: 10px;
        background: linear-gradient(180deg, rgba(2, 222, 255, 1), rgba(4, 148, 243, 1));
        margin-right: 16px;
        .inner {
          width: 50px;
          height: 50px;
          border-radius: 10px;
          margin: 3px auto;
          overflow: hidden;
          img {
            display: inline-block;
            width: 100%;
            height: 100%;
          }
        }
      }
      .name-level {
        margin-top:2px;
        p {
          font-size: 14px;
          font-family: Helvetica;
          color: rgba(144, 255, 252, 1);
          line-height: 21px;
          &:first-child{
            max-width: 84px;
            overflow: hidden;/*超出部分隐藏*/
            white-space: nowrap;/*不换行*/
            text-overflow:ellipsis;/*超出部分文字以...显示*/
          }
        }
      }
    }
    .game-info {
      float: right;
      width: 149px;
      background: url("./images/diamond-box.png") no-repeat center;
      background-size: contain;
      margin: 18px 310px 0 0;
      position: relative;
      .diamond {
        display: inline-block;
        width: 26px;
        height: 26px;
        margin: 4px 0 0 30px;
      }
      .num {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(144, 255, 252, 1);
        line-height: 22px;
        position: absolute;
        right: 10px;
        top: 6px;
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .header-wrapper {
    .header-content {
      width: 100%;
      /*height:105px;*/
      background: url("./images/ipad_bg_study_top.png") no-repeat center top;
      background-size: contain;
      margin-left: 0;
      &.header-content-lenovo {
        background: url("./images/ipad_bg_study_top_lenovo.png") no-repeat center top;
      background-size: contain;
      }
      .cource-info {

        margin: 24px 0 0 160px;
        h2{
          max-width:460px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow:ellipsis;
        }
      }
      .student-info {

      }
      .game-info {
        margin: 18px 30px 0 0;
      }
    }
  }
}

@media screen and (max-width: 960px) {
  .header-wrapper {
    .header-content {
      .cource-info {
        margin: 14px 0 0 95px;
        max-width: 355px;
      }
      .student-info {
        margin-right: 14px;
        .avatar {
          width: 36px;
          height: 36px;
          margin-right: 5px;
          .inner {
            width: 30px;
            height: 30px;
          }
        }
      }
      .game-info {
        margin: 10px 16px 0 0;
        width: 135px;
      }
    }
  }
}
@media screen and (max-width: 814px) {
  .header-wrapper {
    .header-content {
      .cource-info {
        margin: 14px 0 0 95px;
        max-width: 325px;
      }
    }
  }
}
@media screen and (max-width: 700px) {
  .header-wrapper {
    .header-content {
      .cource-info {
        font-size: 16px;
      }
      .game-info {
        width: 110px;
        margin: 5px 16px 0 0;
      }
      .student-info {
        margin-top: 0;
      }
    }
  }
}
@media screen and (max-width:569px){
  .header-wrapper {
    .header-content {
      .cource-info {
        font-size: 14px;
        margin: 10px 0 0 90px;
        width: 270px;
        overflow: hidden;
      }
      .game-info {
        width: 110px;
        margin: 5px 16px 0 0;
      }
      .student-info {
        margin-top: 5px;
        .avatar {
          width: 26px;
          height: 26px;
          .inner {
            width: 20px;
            height: 20px;
          }
        }
        .name-level {
          p {
            font-size: 12px;
            line-height: 13px;
          }
        }
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Header/index.vue